export default __webpack_public_path__ + "static/media/left-img.0f59a146.png";